import { useScreenViewClient } from '../../hooks/useScreenViewClient'

export default function ScreenViewHost() {
  const { pending, busy, error, sharing, secondsLeft, ar, allow, reject, dismiss, stopSharing } =
    useScreenViewClient()

  return (
    <>
      {pending && (
        <div className="fixed bottom-4 inset-x-0 z-[80] flex justify-center px-4 pointer-events-none">
          <div className="pointer-events-auto w-full max-w-lg rounded-2xl bg-white shadow-2xl border border-amber-200 overflow-hidden">
            <div className="bg-amber-500 text-white px-5 py-2.5 font-bold">
              {ar ? 'طلب دعم عن بُعد' : 'Remote Support Request'}
            </div>
            <div className="p-4 space-y-2 text-start">
              <p className="text-gray-900 font-semibold">
                {ar ? 'طلب مشاهدة الشاشة' : 'Screen view request'}
              </p>
              <p className="text-gray-700 text-sm leading-relaxed">
                {ar ? pending.messageAr : pending.messageEn}
              </p>
              <p className="text-sm text-gray-600">
                {ar ? 'مقدم الطلب:' : 'Requested by:'}{' '}
                <strong>{pending.managementUserName || 'Smart Account Support'}</strong>
              </p>
              <p className="text-sm text-amber-700 font-medium">
                {ar ? `ينتهي الطلب خلال ${secondsLeft} ثانية` : `Expires in ${secondsLeft}s`}
              </p>
              {error && <p className="text-sm text-red-600">{error}</p>}
              <div className="flex gap-2 justify-end pt-1">
                <button
                  type="button"
                  onClick={dismiss}
                  className="px-3 py-1.5 rounded-lg bg-gray-200 text-gray-800 font-semibold hover:bg-gray-300 text-sm"
                >
                  {ar ? 'لاحقاً' : 'Later'}
                </button>
                <button
                  type="button"
                  disabled={busy}
                  onClick={() => void reject()}
                  className="px-3 py-1.5 rounded-lg bg-gray-200 text-gray-800 font-semibold hover:bg-gray-300 disabled:opacity-50 text-sm"
                >
                  {ar ? 'رفض' : 'Reject'}
                </button>
                <button
                  type="button"
                  disabled={busy}
                  onClick={() => void allow()}
                  className="px-3 py-1.5 rounded-lg bg-emerald-600 text-white font-semibold hover:bg-emerald-700 disabled:opacity-50 text-sm"
                >
                  {ar ? 'السماح' : 'Allow'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {sharing && (
        <div className="fixed bottom-4 inset-x-0 z-[70] flex justify-center px-4 pointer-events-none">
          <div className="pointer-events-auto flex items-center gap-3 rounded-full bg-emerald-700 text-white px-4 py-2 shadow-lg">
            <span className="inline-block w-2.5 h-2.5 rounded-full bg-lime-300 animate-pulse" />
            <span className="font-semibold text-sm">
              {ar ? 'مشاركة الشاشة نشطة' : 'Screen Sharing Active'}
            </span>
            <button
              type="button"
              onClick={() => void stopSharing()}
              className="ms-2 px-3 py-1 rounded-full bg-white text-emerald-800 text-sm font-bold hover:bg-emerald-50"
            >
              {ar ? 'إيقاف مشاركة الشاشة' : 'Stop Screen Sharing'}
            </button>
          </div>
        </div>
      )}

      {error && !pending && (
        <div className="fixed top-4 inset-x-0 z-[70] flex justify-center px-4">
          <div className="max-w-lg rounded-xl bg-red-50 text-red-800 border border-red-200 px-4 py-2 text-sm shadow">
            {error}
          </div>
        </div>
      )}
    </>
  )
}
